import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { StoreService } from '../../services/store.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { UserService } from '../../services/api/user.service';
import { AlertNotificationService } from '../../services/alert-notification.service';

@Component({
  selector: 'app-login-page',
  imports: [FormsModule],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent {

  username: string = '';
  password: string = '';

  constructor(
    private authService: AuthService,
    private storeService: StoreService,
    private userService: UserService,
    private router: Router,
    private store: Store,
    private alertNotificationService: AlertNotificationService
  ) { }

  async onSubmit(): Promise<void> {
    console.log('onSubmit');
    console.log(this.username, this.password);

    try {
      const response = await lastValueFrom(this.authService.token(this.username, this.password));
      if (response.status.code === 200) {
        console.log('response', response.data.auth.accessToken);
        this.storeService.setAuthToken(response.data.auth);

        this.userService.getMe().subscribe({
          next: (userResponse: any) => {
            if (userResponse.status.code === 200) {
              const user = userResponse?.data?.user;
              this.storeService.setUserData(user);
              localStorage.setItem('user', JSON.stringify(user));

              console.log('userResponse', userResponse);

              this.alertNotificationService.success('Login successful!');
              this.router.navigate(['/']);
            }
          },
          error: (error) => {
            const errorMessage = error?.error?.error?.message || 'Failed to fetch user data. Please try again later.';
            console.error('Error fetching user data:', error);
            this.alertNotificationService.error(errorMessage);
          }
        });
      } else {
        const errorMessage = response.status.error || 'Login error occurred.';
        console.error('Login error:', errorMessage);
        this.alertNotificationService.error(errorMessage);
      }

    } catch (e: any) {
      const errorMessage = e?.error?.error?.message || 'An unexpected error occurred. Please try again later.';
      console.error('An error occurred during login:', e);

      this.alertNotificationService.error(errorMessage);
    }
  }
}
